'use client';
import { toast } from '@ethsign/ui/dist/Toast/use-toast';
import axios, { AxiosRequestConfig } from 'axios';

import { isServer as isServerFunc } from './common';
import { isMobile } from './device';

const isServer = isServerFunc();

const instance = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

instance.interceptors.request.use(async (config: any) => {
  return config;
});

instance.interceptors.response.use((response: any) => {
  const data = response.data;
  if (data.success === false || data.data?.success === false) {
    throw new Error(data.data?.message || data.message || 'Service Failed');
  }
  return response;
});

export interface ResponseData<T> {
  success: boolean;
  message: string;
  data: T;
  statusCode: number;
}

export interface RequestConfig extends AxiosRequestConfig {
  errorHandler?: (e: Error) => void;
}

const request = async <T>(config: RequestConfig): Promise<T> => {
  try {
    const { data } = await instance<ResponseData<T>>(config);

    return data.data;
  } catch (e: any) {
    console.log(e);
    if (config.errorHandler) {
      config.errorHandler(e);
    } else {
      if (!isServer) {
        toast({
          title: 'Error',
          description: e.response?.data?.message || e.message || 'Service Failed',
          variant: 'error'
        });
      } else {
        console.error(e?.message || 'Service Failed', 'error');
      }
    }
    if (e.response?.status === 401 && !isServer) {
      const { pathname, search } = window.location;
      // 如果不是signin页面自动跳转到登录页，如果是详情页且在移动端那么不自动跳转登录页
      if (pathname !== '/signin' && !(pathname.startsWith('/contract') && isMobile())) {
        window.location.href = `/signin/?redirect=${encodeURIComponent(pathname + search)}`;
      }
    }
    throw e;
  }
};

export default request;
